/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Spinner/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Spinner({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Spinner",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 40,
  height = 41,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#E4E7EB",
  fill3 = "#2F8132"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Spinner.Svg"
  data-view-path={viewPath}
 viewBox="0 0 40 41"
 style={{'--as-1-2sJpsP': alignSelf,'--mt-2-2sJpsP': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2sJpsP': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2sJpsP': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2sJpsP': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2sJpsP': opacity,'--w-10-2sJpsP': typeof width === 'number' ? `${width}px` : width,'--h-11-2sJpsP': typeof height === 'number' ? `${height}px` : height,'--f-12-2sJpsP': fill,'--a-7-2sJpsP': isAnimated ? animation : "none",'--sd-8-2sJpsP': isAnimated ? strokeDashoffset : 0,'--sd-9-2sJpsP': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Spinner.SvgPath"
  data-view-path={viewPath}
 d="M40 20.5c0 11.046-8.954 20-20 20s-20-8.954-20-20S8.954.5 20 .5s20 8.954 20 20zm-37 0c0 9.389 7.611 17 17 17s17-7.611 17-17-7.611-17-17-17-17 7.611-17 17z"
 style={{'--f-12-2sJpsP': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Tysiav2Spinner.SvgPath:1"
  data-view-path={viewPath}
 d="M38.5 20.5c.828 0 1.506-.672 1.444-1.499A20.002 20.002 0 0021.499.556C20.673.494 20 1.172 20 2s.673 1.493 1.498 1.566a17 17 0 0115.436 15.436c.073.825.738 1.498 1.566 1.498z"
 style={{'--f-12-2sJpsP': fill3}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}